import { TextField, Button, InputAdornment } from "@material-ui/core";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import AddIcon from "@material-ui/icons/AddOutlined";
import SearchIcon from "@material-ui/icons/SearchOutlined";

const useTopbarStyles = makeStyles((theme) => ({
  topbar: {
    display: "flex",
    backgroundColor: "transparent",
    width: "100%",
    flex: "0 1 auto",
    height: 70,
  },
  icon: {
    display: "flex",
    // @ts-ignore
    marginRight: theme.spacing(1),
  },
  searchWrapper: {
    width: 275,
    minWidth: 275,
    borderBottom: "2px solid rgb(63 63 68 / 15%)",
  },
  searchField: {},
  createButton: {
    whiteSpace: "nowrap",
  },
}));

const TopBar = ({
  searchString,
  onSearchStringChange,
  onNewRule,
  showHeading,
  heading,
}) => {
  const classes = useTopbarStyles();

  return (
    <div className={clsx(classes.topbar)}>
      <div
        className={clsx(
          "bg-white p-4 flex justify-center items-center MuiPaper-elevation1",
          classes.searchWrapper
        )}
      >
        <TextField
          className="w-full"
          variant="outlined"
          name="search"
          autoComplete="off"
          onChange={(e) => onSearchStringChange(e.target.value)}
          value={searchString}
          InputProps={{
            className: clsx(classes.searchField),
            placeholder: "Search rules",
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className={clsx(classes.icon)} />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <div
        className={clsx(
          "px-5 py-4 items-center truncate font-bold text-gray-700 flex-grow"
        )}
      >
        <span className="text-2xl">{showHeading ? heading : ""}</span>
      </div>

      <div className={clsx("p-3 flex justify-center items-center")}>
        <Button
          className={clsx("h-full", classes.createButton)}
          color="primary"
          onClick={() => onNewRule()}
          variant="contained"
        >
          <AddIcon className={classes.icon} />
          Create New Rule
        </Button>
      </div>
    </div>
  );
};

export default TopBar;
